<template>
  <div>
    <el-row>
      <div class="title-h4 mr-b30 mr-t30 dot-title">중요 프로세스 차트(CPU/메모리)</div>
      <w-major-process-scatter-chart ref="majorProcessScatterChart"></w-major-process-scatter-chart>
    </el-row>
    <el-row>
      <el-row type="flex" class="title-bar mr-t30" justify="space-between">
        <div class="title-h4 dot-title">
          중요 프로세스 목록
        </div>
        <div>
          <w-header-search-button size="mini" @click="majorShowSearchTool = !majorShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="majorProcTableData" :columns="majorColumns" :column-default="columnDefault" ref="majorTableRef"
       :show-custom-header="true" :show-search-tool="majorShowSearchTool" :pagination="true">
       <template slot-scope="scope" slot="status-slot">
         <span v-if="scope.row['procStatus'] != null" :class="getStatusAliveClass(scope.row['procStatus'])">{{statusAliveFormatter(scope.row['procStatus'])}}</span>
         <el-tooltip v-else effect="dark" content="자원 미수집" placement="top"><span> - </span></el-tooltip>
       </template>
       <template slot-scope="scope" slot="cpu-slot">
         <el-progress v-if="scope.row.procCpuUserate > 0" :class="progressbarBgcolor(scope.row)" :text-inside="true" :stroke-width="18" :percentage="scope.row.procCpuUserate"></el-progress>
         <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
       </template>
       <template slot-scope="scope" slot="memory-slot">
         <span :style="`color: ${memoryTextColor(scope.row)}`">{{getConvertValuByUnit(scope.row.procMemUsedsize)}}</span>
       </template>
       <template slot-scope="scope" slot="process-control-slot">
         <div v-show="scope.row['procStatus'] === '0'">
           <el-button v-if="isProcessCommand(scope.row.processCommandStart)" type="text" @click="onClickExecuteServerStartMajorProcess(scope.row)">시작</el-button>
           <el-tooltip v-else effect="dark" content="시작 명령어가 없습니다." placement="top"><span> - </span></el-tooltip>
         </div>
         <div v-show="scope.row['procStatus'] === '1'">
           <el-button v-if="isProcessCommand(scope.row.processCommandStop)" type="text" @click="onClickExecuteServerStopMajorProcess(scope.row)">중지</el-button>
           <el-tooltip v-else effect="dark" content="종료 명령어가 없습니다." placement="top"><span> - </span></el-tooltip>
         </div>
         <div v-show="scope.row['procStatus'] === null">
           <el-tooltip effect="dark" content="수집정보가 없습니다." placement="top"><span> - </span></el-tooltip>
         </div>
       </template>
       <template slot-scope="scope" slot="port-alive-slot">
         <span v-if="scope.row.portAlive === '1'">
           <el-tooltip effect="dark" placement="bottom">
             <span slot="content">
               정상
             </span>
             <span :class="[$style['port-alive-check'], $style['port-status-up']]"></span>
           </el-tooltip>
         </span>
         <span v-else-if="scope.row.portAlive === '0'">
           <el-tooltip effect="dark" placement="bottom">
             <span slot="content">
               비정상
             </span>
             <span :class="[$style['port-alive-check'], $style['port-status-down']]"></span>
           </el-tooltip>
         </span>
         <span v-else>
           <el-tooltip effect="dark" placement="bottom">
             <span slot="content">
               미수집
             </span>
             <span :class="[$style['port-alive-check'], $style['port-status-null']]"></span>
           </el-tooltip>
         </span>
       </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import ServiceAPI from '@/api/performance/service/service';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import { cloneDeep, isNil, isEmpty, find } from 'lodash';
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import WMajorProcessScatterChart from '../chart/MajorProcessScatterChart';

const statusFilters = [{ text: '정상', value: '1' }, { text: '비정상', value: '0' }, { text: '미수집', value: null }];
const runningFilters = [{ text: '정상', value: '1' }, { text: '다운상태', value: '0' }, { text: '미수집', value: null }];

export default {
  name: 'WServiceMajorProcessList',
  components: {
    WMajorProcessScatterChart,
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      popoverOligopolyForm: {},
      columnDefault,
      majorShowSearchTool: false,
      majorProcTableData: [],
      changeFlag: true,
      majorColumns: [
        { prop: 'procStatus', label: '동작상태', width: 90, sortable: true, scopedSlot: 'status-slot', filters: runningFilters },
        { prop: 'managetypeName', label: '관리타입', width: 120 },
        { prop: 'objName', label: '장비명', width: 200, sortable: true, searchable: true },
        { prop: 'processId', label: '프로세스 ID', width: 130, remoteProp: 'smp.process_id', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'processName', label: '프로세스명', remoteProp: 'smp.process_name', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'processPort', label: '포트', width: 90, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'portAlive', label: '포트상태', sortable: true, width: 100, scopedSlot: 'port-alive-slot', filters: statusFilters },
        { prop: 'procCpuUserate', label: 'CPU (%)', width: 120, sortable: true, scopedSlot: 'cpu-slot' },
        { prop: 'procMemUsedsize', label: '메모리', width: 80, sortable: true, scopedSlot: 'memory-slot' },
        { label: '제어', width: '70px', scopedSlot: 'process-control-slot' },
      ],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      this.loadProcessOverloadSettings();
      // data
      ServiceAPI.getServiceMajorProcessData({ serviceId: this.selectedNode.obj.objId, viewType: 'table' }).then((res) => {
        if (res.data.success) {
          this.majorProcTableData = res.data.data;
          this.$refs.majorProcessScatterChart.setData(cloneDeep(res.data.data));
        }
      });
    },
    statusAliveFormatter(value) {
      if (isNil(value)) { return EMPTY_TEXT; }
      switch (value) {
        case '0' : return '다운상태';
        case '1' : return '정상';
        default: return EMPTY_TEXT;
      }
    },
    formatterForProcCount(row, column, value) {
      return isNil(value) ? 0 : value;
    },
    getConvertValuByUnit(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'KB', true, false, true);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onClickExecuteServerStartMajorProcess(row) {
      serverTableInfoAPI.executeServerStartMajorProcess({ serverId: row.serverId, processCommandStart: row.processCommandStart, procName: row.processName })
        .then((result) => {
          if (result.data.success) {
            this.majorloadStore();
            this.successNotification('프로세스 시작 명령어');
          } else {
            this.failureNotification('프로세스 시작 명령어');
          }
        });
    },
    onClickExecuteServerStopMajorProcess(row) {
      serverTableInfoAPI.executeServerStopMajorProcess({ serverId: row.serverId, processCommandStop: row.processCommandStop, procName: row.procName })
        .then((result) => {
          if (result.data.success === true) {
            this.majorloadStore();
            this.successNotification('프로세스 중지 명령어');
          } else {
            this.failureNotification('프로세스 중지 명령어');
          }
        });
    },
    loadProcessOverloadSettings() {
      ServiceAPI.getProcessOverloadSettings({ serviceId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success === true) {
          this.popoverOligopolyForm = response.data.data;
        }
      });
    },
    memoryTextColor(row) {
      let targetData = 0;
      let resultColor = 'black';
      targetData = find(this.popoverOligopolyForm, ['objId', row.serverId]);
      if (targetData && !isNil(row)) {
        resultColor = row.procMemUsedsize > (targetData.processMaxMemLimit * 1024) ? 'red' : 'black';
      }
      return resultColor;
    },
    isProcessCommand(value) {
      return !isEmpty(value);
    },
    getStatusAliveClass(value) {
      if (value === '0') {
        return 'state-abnormal';
      } else if (value === '1') {
        return 'state-normal';
      }
      return '';
    },
    progressbarBgcolor(row) {
      let targetData = 0;
      let resultColor = '';
      targetData = find(this.popoverOligopolyForm, ['objId', row.serverId]);
      if (targetData && !isNil(row)) {
        resultColor = row.procCpuUserate > (targetData.processMaxCpuLimit) ? 'abnormal' : '';
      }
      return resultColor;
    },
  },
};
</script>

<style module lang="scss">
.port-alive-check {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.port-status-up {
  background-color: rgb(92, 189, 95);
}
.port-status-down {
  background-color: rgb(255, 78, 94);
}
.port-status-null {
  background-color: #b1aaab;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/components/ServiceMajorProcessList.vue